paymentTokenRefusalReason